module.exports = __webpack_public_path__ + "img/incoHot.93965bde.png";